import { IHeatSupplyDefect } from "../data/heatSupplyForm/types";

export const initialValuesHeatSupply: IHeatSupplyDefect = {
  mediaCoverage: false,
  mediaComment: null,
  incidentStatusId: null,
  objectTypeId: null,
  classifierTypeId: null,
  objectId: null,
  objectShortName: "",
  statusComment: "",
  districtId: null,
  addressText: null,
  dateTimeDisable: null,
  dateTimePlanned: null,
  dateTimeEnable: null,
  timeDisable: "",
  gasPlannedTime: "",
  timeEnable: "",
  disconnectedSubscribers: null,
  responsible: null,
  responsiblePhone: null,
  comment: "",
  eventTypeId: null,
  gridTypeId: 1,
  buildings: null,
  overBuildings: null,
  livingBuildings: null,
  hospitalBuildings: null,
  childrenBuildings: null,
  typeGasketId: null,
  diameter: null,
  defNatureId: null,
  standartTime: null,
  addressNote: "",
  activityTypeId: null,
  uniqueIdentifier: null,
  addressDisconnexion: null,
  typePipeId: null,
  defectExternalManifestationId: null,
  heatSource: null,
  externalSystemId: 1,
  externalId: null,
  files: [],
  organizationId: null,
  addressAreaId: null,

  mkaDecisionStatusId: null,
  fullOfMkdCount: null,
  partialOfMkdCount: null,
  connectedOfMkdCount: null,
  shouldBeSendToMka: false,

  municipalityText: "",
  mkaUtilitiesSectorId: null,
  incidentDescription: null,
  parentId: null,
  mkaTechonologicalProcessStageId: null,
  mkaObjectKindId: null,
  mkaObjectType: null,
  mkaObjectName: null,
  mkaIncidentTypeId: null,
  deadCount: null,
  affectedCount: null,
  weather: null,
  fullFact: false,
  fullListOfLocation: null,
  fullListOfObjects: null,
  fullOfSocialObjectsCount: null,
  fullListOfMkd: [],
  fullOfMkdPplCount: null,
  fullOfPrivateHousesCount: null,
  fullOfPrivateHousesPplCount: null,
  fullListOfObjectsOther: null,
  partialFact: false,
  partialListOfLocation: null,
  partialListOfObjects: null,
  partialOfSocialObjectsCount: null,
  partialListOfMkd: [],
  partialOfMkdPplCount: null,
  partialOfPrivateHousesCount: null,
  partialOfPrivateHousesPplCount: null,
  partialListOfObjectsOther: null,
  connectedFact: false,
  connectedListOfCommunalServices: null,
  connectedListOfLocation: null,
  connectedListOfObjects: null,
  connectedOfSocialObjectsCount: null,
  connectedListOfMkd: [],
  connectedOfMkdPplCount: null,
  connectedOfPrivateHousesCount: null,
  connectedOfPrivateHousesPplCount: null,
  connectedListOfObjectsOther: null,
  objectOwnerName: null,
  operatingOrganizationName: null,
  planResponsibles: null,
  additionalInformation: null,
  operationalInformationSource: null,
};
